import { Flex, Spin, Typography } from "@payping/web-components";

import useTranslator from "@/shared/translate/translator";
import { useGetWalletBalance } from "@/refund/use-cases";
import classNames from "classnames";
import { CuToman } from "@payping/icons";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";

type Props = {
  titleClassName?: string;
  amountClassName?: string;
  currencyClassName?: string;
};
const Balance: React.FC<Props> = ({ titleClassName = "", amountClassName = "" }) => {
  const { t } = useTranslator("refund.wallet");

  const walletBalance = useGetWalletBalance();

  return (
    <Flex justify="center" align="center" vertical gap="13px">
      <Typography.Text type="secondary" className={titleClassName}>
        {t("accessibleBalance")}
      </Typography.Text>
      <Flex align="center" gap="small">
        <Spin spinning={walletBalance.isLoading}>
          <Flex align="center" vertical gap="4px">
            <Flex align="center">
              <Typography.Title level={2} className={classNames("tw:m-0!", amountClassName)}>
                {formatLocalizedNumber({
                  value: walletBalance.data?.accessibleBalance ?? 0,
                  options: { maximumFractionDigits: 2 },
                })}
              </Typography.Title>
              <CuToman width={24} height={24} />
            </Flex>
            <Flex align="center">
              <Typography.Text type="secondary" className="tw:text-sm">
                {t("balance")}:&nbsp;
              </Typography.Text>
              <Typography.Text strong>
                {formatLocalizedNumber({
                  value: walletBalance.data?.totalBalance ?? 0,
                  options: { maximumFractionDigits: 2 },
                })}
              </Typography.Text>
              <CuToman width={24} height={24} style={{ marginLeft: 4 }} />
            </Flex>
          </Flex>
        </Spin>
      </Flex>
    </Flex>
  );
};
export default Balance;
